import { ReactNode } from 'react';
import styles from './styles.module.scss';

type CardBannerProps = {
  children?: ReactNode;
};

export const CardBanner = ({ children }: CardBannerProps) => (
  <div className={styles.cardBanner}>{children}</div>
);
